/* src/app/admin-dashboard/delivery/drivers/drivers.component.css */
.dv-wrap {
  padding: 16px;
}
.dv-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.dv-spacer {
  flex: 1 1 auto;
}
.dv-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 760px;
}
.dv-error {
  color: #c0392b;
  padding: 8px 0;
}
.dv-empty {
  padding: 24px;
  text-align: center;
  color: #888;
}
.dv-chip {
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
  white-space: nowrap;
}
.dv-chip-ok {
  background: #e8f5e9;
  color: #2e7d32;
}
.dv-chip-off {
  background: #f0f0f0;
  color: #888;
}
.dv-search {
  width: 340px;
  max-width: 100%;
}
.dv-search .mat-mdc-form-field-icon-prefix {
  padding-right: 6px;
  color: #888;
}
.dv-card {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  background: #fbfcfd;
}
.dv-card-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
}
.dv-form-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.dv-field {
  flex: 1 1 260px;
  min-width: 240px;
}
.dv-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
.dv-picker {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  background: #fff;
  margin-top: 4px;
}
.dv-picker-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px 4px;
  flex-wrap: wrap;
}
.dv-picker-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 4px 0;
}
.dv-picker-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}
.dv-picker-item:hover {
  background: #f5f7f9;
}
.dv-picked {
  background: #eef5ff;
}
.dv-picker-name {
  font-weight: 500;
}
.dv-chip-warn {
  background: #fdecea;
  color: #c0392b;
}
.dv-muted {
  color: #888;
  font-size: 12px;
}
.dv-cust-cell {
  max-width: 280px;
}
.dv-cust-chip {
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eef1f4;
  color: #333;
  font-size: 12px;
}
.dv-table-wrap {
  overflow-x: auto;
}
.dv-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.dv-table th,
.dv-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}
.dv-table th {
  color: #666;
  font-weight: 600;
}
.dv-row-off td {
  background: #fafafa;
  color: #999;
}
.dv-actions {
  white-space: nowrap;
  text-align: right;
}
.dv-support summary {
  cursor: pointer;
  margin-bottom: 0;
}
.dv-support[open] summary {
  margin-bottom: 12px;
}
.dv-support .dv-form-row {
  align-items: center;
}
.dv-tab-count {
  margin-left: 8px;
  padding: 1px 8px;
}
.dv-settings {
  padding: 16px 24px;
  max-width: 900px;
}
.dv-settings h4 {
  margin: 0 0 4px;
}
.dv-page {
  padding-top: 16px;
}
.dv-tab-note {
  margin: 12px 24px 0;
  color: rgba(0, 0, 0, 0.6);
}
.dv-badge {
  display: inline-block;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  margin-left: 8px;
  padding: 0 6px;
  border-radius: 10px;
  background: #e53935;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
}
/*# sourceMappingURL=drivers.component.css.map */
